import { defineMessages } from 'react-intl';

export default defineMessages({
  next: {
    id: 'frontbucket.pagination.nextLink',
    description: 'Link text for next page of results',
    defaultMessage: 'Next',
  },
  previous: {
    id: 'frontbucket.pagination.previousLink',
    description: 'Link text for previous page of results',
    defaultMessage: 'Prev',
  },
});
